import logger from "services/LoggingService";

export const reduxLogger = (store) => (next) => (action) => {
  const result = next(action);
  logger.debug(`REDUX dispatching: ${action.type}`, store.getState());
  return result;
};